import * as React from 'react';

const XCircle = props => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    stroke="#DE615E"
    strokeWidth={2}
    fill="none"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <circle cx={11} cy={11} r={10} />
    <path d="M14,8 L8,14" />
    <path d="M8,8 L14,14" />
  </svg>
);

export default XCircle;



// WEBPACK FOOTER //
// ./src/assets/images/icons/x-circle.js